import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetServicePointsUfs,
	GetServicePointsUfsModel,
	GetServicePointsUfsParams,
} from 'domain/usecases/private/service-points/get-service-points-ufs';

export class RemoteGetServicePointsUfs implements GetServicePointsUfs {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetServicePointsUfsModel>,
	) {}

	async get({signal, ...params}: GetServicePointsUfsParams): Promise<GetServicePointsUfsModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			signal,
			params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
